export const UI_DIMENSIONS = {
  columnWidthPrice: 130,
  columnWidthSelect: 122,
  columnWidthSwitch: 140,
  columnWidthIcon: 30,
  columnWidthEntitySelect: 210,
  columnWidthEntityTag: 210,
  columnWidthText: 150,
  defaultGridScrollbarWidth: 15,
  columnMiddleWidthIcon: 100,
  columnSmallWidthIcon: 60,
};
